<ng-container *ngIf="loaded">
  <router-outlet></router-outlet>
</ng-container>
